<div id="capAlertsEnableModalDialog">
  <div class="cap-alerts-enable-modal__header">
    <mat-icon
      class="integration-logo"
      svgIcon="integration-cap-alerts"
      aria-hidden="true"
    ></mat-icon>
    <h3 class="cap-alerts-enable-modal__header-title">CAP Alerts</h3>
    <button
      type="button"
      id="closeButton"
      mat-icon-button
      class="close"
      [disabled]="capAlertsService.isLoading"
      data-close="modal"
      aria-label="Click to close this modal"
      (click)="cancel()"
    >
      <mat-icon svgIcon="close" />
    </button>
  </div>

  <div
    class="cap-alerts-enable-modal__spinner-host"
    rvSpinner="cap-alerts-enable-modal"
    [rvShowSpinner]="capAlertsService.isLoading"
  >
    <mat-dialog-content>
      <div class="cap-alerts-enable-modal__body">
        <h2 class="alerts-heading">Accept Terms &amp; Conditions</h2>

        <div class="alert-card alert-card--terms">
          <p class="alert-card__title">
            Common Alerting Protocol Emergency Messaging Disclaimer
          </p>

          <p class="alert-card__text" id="termsText">
            “Common Alerting Protocol Emergency Messaging” (“CAP Alerts”) is a
            system that allows the dissemination of emergency messages over a
            variety of public alerting systems.
          </p>
          <p class="alert-card__text" id="termsText2">
            CAP Alerts is provided by independent third parties (“CAP Alerts
            Providers”) whom you select. You shall be solely responsible for
            ensuring the CAP Alerts service you select is configured, tested,
            and maintained to meet your needs. Neither Rise Vision nor hardware
            manufacturer of hardware products which include, display or
            otherwise utilize Rise Vision software, or distributors or resellers
            of Rise Vision software, are sellers of CAP Alerts and none provide
            any warranty or assume any liability for the performance, accuracy,
            or timely delivery of CAP Alerts, including connectivity failures,
            user configuration issues, or false, hacked, erroneous, missed, or
            delayed CAP Alerts.
          </p>
          <p class="alert-card__text" id="termsText3">
            Rise Vision suggests that before implementing CAP Emergency
            Messaging you and/or your CAP Alerts Provider (a) connect to Rise
            Vision with the more secure HTTPS, not HTTP; (b) require an
            Authentication Name and Password for the connection; (c) ensure that
            your Displays have a stable internet connection for timely receipt
            of CAP Emergency Messaging; and (d) conduct periodic testing
            according to your own policies.
          </p>
        </div>

        <div class="form-group u_remove-bottom i-accept-flag">
          <mat-checkbox
            id="termsAcceptedCheckbox"
            (ngModelChange)="termsAccepted = $event"
            [ngModel]="termsAccepted"
            [disabled]="fieldsDisabled"
            aria-labelledby="iAcceptLabel"
            [ariaChecked]="termsAccepted"
            ariaCheckedElementId="termsAcceptedCheckbox-input"
          />
          <label
            id="iAcceptLabel"
            for="termsAcceptedCheckbox-input"
            class="mb-0 u_clickable"
            >I accept this Disclaimer and Acknowledgement
          </label>
        </div>
      </div>
    </mat-dialog-content>
  </div>

  <mat-dialog-actions align="end" class="cap-alerts-enable-modal__actions">
    <button
      id="capAlertsEnableModalCancelButton"
      type="button"
      matButton="outlined"
      [disabled]="capAlertsService.isLoading"
      (click)="cancel()"
    >
      Cancel
    </button>
    <button
      id="capAlertsEnableModalSaveButton"
      type="button"
      mat-flat-button
      color="primary"
      [disabled]="!canSave"
      (click)="saveAndContinue()"
    >
      Save and continue
    </button>
  </mat-dialog-actions>
</div>
